/* Aviso rápido no rodapé da tela. */

import { $ } from './dom';

let timer: number | undefined;

export function toast(msg: string): void {
  const t = $('#toast');
  t.textContent = msg;
  t.classList.add('show');
  window.clearTimeout(timer);
  timer = window.setTimeout(() => t.classList.remove('show'), 3800);
}
